// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hF5V","col":"styles_col__2hF1A","actions":"styles_actions__3J2NZ","conflict":"styles_conflict__zuL4e"};